/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Button, Modal, Spinner,
} from 'reactstrap';
import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import BaseGrid from '../Common/BaseGrid';
import { get, post } from '../../helpers/api_helper';
import CategoryTagGroups from './CategoryTagGroups';

function CategoryLayout(props) {
  const { t, treeId, parentId } = props;
  const [categories, setCategories] = useState([]);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [inserting, setInserting] = useState(false);
  const [, setError] = useState(null);
  const [childId, setChildId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showDeleteDisclaimer, setShowDeleteDisclaimer] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [reloadSignal, setReloadSignal] = useState(0);
  const [sampleSignal, setSampleSignal] = useState(0);

  const downloadCats = async () => {
    try {
      let result;
      const config = {
        params: {
          with_count: false,
        },
      };

      if (parentId !== null) {
        result = await get(`/api/listings/tree/${treeId}/cats/${parentId}`, config);
      } else {
        result = await get(`/api/listings/tree/${treeId}/cats`, config);
      }

      setCategories(result.results);
      setError(null);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    }
  };

  const selectCategory = (x) => {
    setSelectedCategory(x);
  };

  const updateCategory = async (id, data) => {
    try {
      setSaving(true);
      await post(`/api/listings/category/${id}/save`, data);
      setError(null);
      setSelectedCategory(null);
      downloadCats();
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    } finally {
      setSaving(false);
    }
  };

  const insertCategory = async (data) => {
    try {
      setInserting(true);

      const newData = { ...data };
      newData.parent_id = parentId;
      newData.tree_id = treeId;

      setError(null);
      await post('/api/listings/category/create', newData);
      setShowAddCategory(false);
      downloadCats();
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    } finally {
      setInserting(false);
    }
  };

  const deleteCategory = async () => {
    try {
      setError(null);
      await post(`/api/listings/category/delete/${showDeleteDisclaimer}`, '');
      downloadCats();
      setShowDeleteDisclaimer(false);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    }
  };

  useEffect(() => {
    // Fetch child categories based on the parentId
    const fetchChildCategories = async () => {
      setLoading(true);
      await downloadCats();
      setLoading(false);
    };

    fetchChildCategories();
  }, [parentId, treeId, reloadSignal]);

  useEffect(() => {
    let cancelled = false;

    if (!categories.length) {
      setCategoryCounts({});
      return () => {
        cancelled = true;
      };
    }

    const ids = categories.map((category) => category.id);

    setCategoryCounts(
      ids.reduce((accumulator, id) => ({
        ...accumulator,
        [id]: {
          loading: true,
          count: null,
        },
      }), {}),
    );

    let nextIndex = 0;

    const fetchCategoryCount = async (categoryId) => {
      try {
        const result = await get(`/api/listings/category/${categoryId}/listing-count`);

        if (cancelled) {
          return;
        }

        setCategoryCounts((previous) => ({
          ...previous,
          [categoryId]: {
            loading: false,
            count: Number(result.count),
          },
        }));
      } catch (err) {
        if (cancelled) {
          return;
        }

        setCategoryCounts((previous) => ({
          ...previous,
          [categoryId]: {
            loading: false,
            count: null,
          },
        }));
      }
    };

    const worker = async () => {
      const currentIndex = nextIndex;
      nextIndex += 1;

      if (cancelled || currentIndex >= ids.length) {
        return;
      }

      await fetchCategoryCount(ids[currentIndex]);
      await worker();
    };

    const workerCount = Math.min(4, ids.length);

    for (let i = 0; i < workerCount; i += 1) {
      worker();
    }

    return () => {
      cancelled = true;
    };
  }, [categories]);

  const validationSchema = Yup.object().shape({
    id: Yup
      .number(),
    name: Yup
      .string()
      .required(props.t('Name is required'))
      .matches(/^[a-zA-Z0-9- :!@#$%^&*()./]+$/, props.t('Strange characters detected.')),
    priority: Yup
      .number(),
  });

  return (
    <>
      <div>
        {loading ? (
          <div className="mt-3">{t('Loading categories...')}</div>
        ) : (
          <>
            {categories.map((x) => {
              const countState = categoryCounts[x.id] || { loading: false, count: null };

              return (
                <div key={`cat_${x.id}`} className="pt-2 pb-2" style={{ position: 'relative' }}>
                  {childId !== x.id && (
                    <span className={`mdi mdi-plus-box-outline ${x.children.length > 0 ? 'text-dark' : 'text-dark text-opacity-50'}`} style={{ cursor: 'pointer', fontSize: '25px' }} onClick={() => { setChildId(x.id); }} />
                  )}
                  {childId === x.id && (
                    <span className="mdi mdi-minus-box-outline text-danger" style={{ cursor: 'pointer', fontSize: '25px' }} onClick={() => { setChildId(null); }} />
                  )}
                  {' '}
                  {selectedCategory !== x.id && (
                    <a
                      href="#"
                      onClick={() => { setShowEditModal(x); }}
                      style={
                        {
                          fontSize: '18px',
                          position: 'relative',
                          top: '-3px',
                          left: '4px',
                        }
                      }
                    >
                      {x.name}
                      <small className="text-dark">
                        {' '}
                        {countState.loading ? (
                          <Spinner size="sm" style={{ width: '0.8rem', height: '0.8rem' }} />
                        ) : (
                          <>
                            (
                            {countState.count ?? '-'}
                            )
                          </>
                        )}
                      </small>
                    </a>
                  )}

                  {selectedCategory !== x.id && (
                    <a
                      href="#"
                      style={{
                        fontSize: '19px',
                        position: 'relative',
                        top: '-1px',
                        left: '10px',
                      }}
                      className="text-dark text-opacity-50"
                      onClick={() => { selectCategory(x.id); }}
                    >
                      <span className="mdi mdi-pencil" />
                    </a>
                  )}

                  <sub
                    style={{
                      fontSize: '10px',
                      position: 'absolute',
                      top: '30px',
                      right: '10px',
                    }}
                  >
                    {t('Sort:')}
                    {' '}
                    {x.priority}
                  </sub>

                  {selectedCategory === x.id && (
                    <div
                      style={
                        {
                          fontSize: '18px',
                          position: 'relative',
                          top: '-3px',
                          left: '4px',
                          display: 'inline-block',
                          padding: '10px 20px',
                          background: '#fbfbfb',
                          borderRadius: '4px',
                        }
                      }
                    >
                      {!saving && (
                        <Formik
                          enableReinitialize
                          initialValues={{ id: x.id, name: x.name, priority: x.priority }}
                          validationSchema={validationSchema}
                          onSubmit={(values) => {
                            updateCategory(x.id, values);
                          }}
                        >
                          {({
                            touched, errors,
                          }) => (
                            <Form id="new_tree_form">
                              <Row>
                                <Col sm={6}>
                                  <Field
                                    type="text"
                                    className={`form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                                    id={`cat_${x.id}_name`}
                                    name="name"
                                    placeholder={x.name}
                                    // eslint-disable-next-line jsx-a11y/no-autofocus
                                    autoFocus
                                    style={{ minWidth: '200px' }}
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="text-danger mt-2"
                                    style={{ fontSize: '10px' }}
                                  />
                                </Col>
                                <Col sm={3}>
                                  <Field
                                    type="number"
                                    className={`form-control ${(errors.priority && touched.priority ? 'is-invalid' : '')}`}
                                    id={`cat_${x.id}_priority`}
                                    name="priority"
                                    placeholder={t('priority')}
                                  />
                                  <ErrorMessage
                                    name="priority"
                                    component="div"
                                    className="text-danger mt-2"
                                    style={{ fontSize: '10px' }}
                                  />
                                </Col>
                                <Col sm={3}>
                                  <Button title={t('Save')} type="submit" color="success" className="btn-soft-success">
                                    <span className="mdi mdi-check" />
                                  </Button>
                                  <Button title={t('Delete')} color="danger" className="btn-soft-danger ms-2" onClick={() => { setShowDeleteDisclaimer(x.id); }}>
                                    <span className="mdi mdi-trash-can" />
                                  </Button>
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      )}
                      {saving && (
                        <span style={{ fontSize: '14px' }}>{t('Saving...')}</span>
                      )}
                    </div>
                  )}

                  {childId !== null && x.id === childId && (
                    <div style={{ marginLeft: '11px', paddingLeft: '15px', borderLeft: '2px dashed #555' }}>
                      <CategoryLayout parentId={childId} treeId={treeId} />
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>

      <div className="" style={{ fontSize: '15px' }}>
        {showAddCategory && (
          <div>
            {!inserting && (
              <Formik
                enableReinitialize
                initialValues={{ name: '', priority: 10 }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  insertCategory(values);
                }}
              >
                {({
                  touched, errors,
                }) => (
                  <Form id="new_tree_form">
                    <Row>
                      <Col sm={6}>
                        <Field
                          type="text"
                          className={`form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                          name="name"
                          placeholder={t('Name')}
                          // eslint-disable-next-line jsx-a11y/no-autofocus
                          autoFocus
                          style={{ minWidth: '200px' }}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger mt-2"
                          style={{ fontSize: '10px' }}
                        />
                      </Col>
                      <Col sm={3}>
                        <Field
                          type="number"
                          className={`form-control ${(errors.priority && touched.priority ? 'is-invalid' : '')}`}
                          name="priority"
                          placeholder={t('priority')}
                        />
                        <ErrorMessage
                          name="priority"
                          component="div"
                          className="text-danger mt-2"
                          style={{ fontSize: '10px' }}
                        />
                      </Col>
                      <Col sm={3}>
                        <Button title={t('Save')} type="submit" color="success" className="btn-soft-success">
                          <span className="mdi mdi-check" />
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            )}

            {inserting && (
              <span style={{ fontSize: '15px;' }}>{t('Inserting...')}</span>
            )}
          </div>
        )}

        {!showAddCategory && (
          <div style={{ marginLeft: '5px' }}>
            <a href="#" title={t('New Category')} onClick={() => { setShowAddCategory(true); }}>
              <span className="mdi mdi-plus-thick" />
            </a>
          </div>
        )}
      </div>

      <Modal
        size="sm"
        isOpen={showDeleteDisclaimer !== false}
      >
        <div className="modal-header">
          <h5
            className="modal-title mt-0"
            id="myLargeModalLabel"
          >
            {t('Disclaimer')}
          </h5>
          <button
            onClick={() => setShowDeleteDisclaimer(false)}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h4>{t('You are about to delete a category!')}</h4>
          <p>{t('This will also delete all sub-categories under this category')}</p>
          <p>{t('The result will potentially cascade to frontend platforms as well, if they are attached in some way.')}</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => setShowDeleteDisclaimer(false)}
            className="btn btn-soft-dark"
            data-dismiss="modal"
          >
            {t('Cancel')}
          </button>
          <button
            type="submit"
            className="btn btn-danger"
            onClick={deleteCategory}
          >
            {t('Delete Anyway')}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={showEditModal !== false}
        scrollable
        size="lg"
        backdrop="static"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">{showEditModal.name}</h5>
          <button type="button" className="btn-close" onClick={() => { setShowEditModal(false); }} aria-label="Close" />
        </div>
        <div className="modal-body">
          {showEditModal !== false && (
            <>
              <CategoryTagGroups
                categoryId={showEditModal.id}
                onSuccess={() => {
                  setReloadSignal(reloadSignal + 1); setSampleSignal(sampleSignal + 1);
                }}
              />

              <hr />
              <h5>{t('Matched Listings Sample')}</h5>
              <BaseGrid
                url={`/api/listings/category/${showEditModal.id}/listings`}
                hasSearch={false}
                shouldUpdate={sampleSignal}
                config={
                {
                  columns: {
                    thumb: {
                      label: '',
                      image: {
                        src: (item) => (`/api/listings/thumbnail/${item.id}`),
                        class: 'rounded',
                        style: { maxHeight: '5rem', maxWidth: '5rem' },
                      },
                      translate: false,
                    },
                    id: { label: 'ID', sort: true },
                    sku: { label: 'Sku', sort: true },
                    title: { label: 'Title', sort: true },
                  },
                  pagination: {
                    sort: 'id',
                    direction: 'desc',
                    perPage: 20,
                  },
                }
                }
              />
            </>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => { setShowEditModal(false); }}
          >
            {t('Close')}
          </button>
          <button type="submit" form="cat_tag_groups" className="btn btn-primary">{t('Save')}</button>
        </div>
      </Modal>
    </>
  );
}

CategoryLayout.defaultProps = {
  t: (x) => (x),
  parentId: null,
};

CategoryLayout.propTypes = {
  parentId: PropTypes.number,
  treeId: PropTypes.number.isRequired,
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(CategoryLayout));
